import script from "./KioskAdminGate.vue?vue&type=script&setup=true&lang=js"
export * from "./KioskAdminGate.vue?vue&type=script&setup=true&lang=js"

import "./KioskAdminGate.vue?vue&type=style&index=0&id=c41919c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c41919c2"]])

export default __exports__